/* eslint-disable max-len */
import Mockup from '@propertypal/shared/src/resources/images/listing-a-development/dev-what-you-get.png';
import React from 'react';
import { Box } from '../layout';
import { Text } from '../typography';
import {
  FeaturesContainer,
  FeaturesWrapper,
  FeaturesSectionContainer,
  FeaturesSectionImage,
  FeaturesSectionTitle,
  FeaturesList,
  FeaturesItem,
} from './ProductsFeatures.style';

const featureItems = [
  `Overview of your development with a list of property types`,
  `Dedicated page for each property type with list of available units`,
  `Dedicated placement for Floorplans`,
  `24 hour, 7 days a week advert for your development `,
  `Developer and selling agent logos`,
  `Contact details for you and your selling agent`,
  `Property types will appear in both the new homes and residential sales search results`,
];

const ListingADevelopmentFeatures: React.FC = () => {
  return (
    <FeaturesContainer>
      <FeaturesWrapper maxW={1120}>
        <FeaturesSectionContainer align="start" contentWidth={650} bp={1080}>
          <FeaturesSectionImage src={Mockup.src} alt="Estate Agent Premier Listing" maxW={625} laptopMaxW={500} />
          <Box maxWidth={465}>
            <FeaturesSectionTitle fontSize={22} mb={20} maxWidth={320}>
              What you get when you list a Development on PropertyPal
            </FeaturesSectionTitle>
            <FeaturesList>
              {featureItems.map((f) => (
                <FeaturesItem key={f}>
                  <Text>{f}</Text>
                </FeaturesItem>
              ))}
            </FeaturesList>
          </Box>
        </FeaturesSectionContainer>
      </FeaturesWrapper>
    </FeaturesContainer>
  );
};

export default ListingADevelopmentFeatures;
